import React, { FC } from 'react';
import { PassengersToolbarProps } from '../../types';
import { useUpdateTravellers } from '../../../../../../../ConfirmOption/hooks';
import PassengersToolbarWithoutForm from '../PassengersToolbarWithoutForm/PassengersToolbarWithoutForm';

const PassengersToolbarWithForm: FC<PassengersToolbarProps> = props => {
	const { setNextStep } = props;

	const updateTravellers = useUpdateTravellers({ setNextStep });

	return <PassengersToolbarWithoutForm updateTravellers={updateTravellers} {...props} />;
};

export default PassengersToolbarWithForm;
